module.exports = {
  APP_VERSION_MAJOR: 9, // Max is 99
  APP_VERSION_MINOR: 7, // Max is 99
  APP_VERSION_PATCH: 0, // Max is 99
  BUILD_VERSION: 1, // Max is 999
};
